import React, { useState } from 'react';
import { X, Loader2 } from 'lucide-react';
import { useToast } from '../../context/ToastContext';
import '../../styles/desktop/EnterpriseInquiryModal.css';

const EnterpriseInquiryModal = ({ isOpen, onClose, initialPackage }) => {
  const { showSuccess, showError } = useToast();
  const [formData, setFormData] = useState({
    packageType: initialPackage || 'hr',
    contact: '',
    inquiry: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('http://localhost:5000/api/enterprise/send-inquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        showSuccess('문의가 접수되었습니다. 곧 연락드리겠습니다! 📧');
        onClose();
        setFormData({
          packageType: 'hr',
          contact: '',
          inquiry: ''
        });
      } else {
        showError('문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      console.error('문의 전송 실패:', error);
      showError('네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="enterprise-inquiry-overlay" onClick={onClose}>
      <div className="enterprise-inquiry-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        <h2 className="modal-title">기업 패키지 문의</h2>
        
        <form onSubmit={handleSubmit} className="inquiry-form">
          <div className="form-group">
            <label className="form-label">패키지 선택</label>
            <div className="radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="packageType"
                  value="hr"
                  checked={formData.packageType === 'hr'}
                  onChange={handleInputChange}
                  className="radio-input"
                />
                <span className="radio-text">HR 패키지</span>
                <span className="radio-description">재취업 교육 대규모 인원용</span>
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="packageType"
                  value="recruiter"
                  checked={formData.packageType === 'recruiter'}
                  onChange={handleInputChange}
                  className="radio-input"
                />
                <span className="radio-text">리크루터 패키지</span>
                <span className="radio-description">헤드헌터·에이전시용</span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="contact" className="form-label">
              연락처 (이메일 또는 전화번호) <span className="required">*</span>
            </label>
            <input
              type="text"
              id="contact"
              name="contact"
              value={formData.contact}
              onChange={handleInputChange}
              placeholder="example@email.com 또는 010-1234-5678"
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="inquiry" className="form-label">
              문의 내용 <span className="required">*</span>
            </label>
            <textarea
              id="inquiry"
              name="inquiry"
              value={formData.inquiry}
              onChange={handleInputChange}
              placeholder="문의하실 내용을 자유롭게 작성해주세요.
작성하신 연락처로 연락 드리겠습니다."
              className="form-textarea"
              rows="5"
              required
            />
          </div>

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Loader2 className="loading-spinner" />
                전송 중...
              </>
            ) : (
              '문의하기'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnterpriseInquiryModal;